import request from '@/utils/request'

const api = {
    projectList:'/project/list',
}

export default api

export function getProjectList(data) {
    return request({
        url: api.projectList,
        method: 'post',
        data
    })
}